import React from 'react';
import Cookie from 'js-cookie';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { DownOutlined } from '@ant-design/icons';
import { Avatar, Dropdown, Menu, Space, Button, Spin } from 'antd';

import useGetLang from '@src/utils/hooks/useGetLang';
import { headPortraitRoutes } from '@src/routes/mainRoutes';
import { UserInfoStore } from '@src/store/UserInfoData/Provider';
import { resetCookie } from '@src/utils/pendingInitInfo';

import styles from './styles.module.less';

const HeadPortraitSelect = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const getLang = useGetLang();

  const { state } = React.useContext(UserInfoStore);

  const onLangChange = (lang) => {
    i18n.changeLanguage(lang);
    sessionStorage.setItem('oper_lang', lang);
  };

  const onLogout = () => {
    localStorage.removeItem('operatorU');
    localStorage.removeItem('operatorP');
    resetCookie();
    navigate('/login');
    // window.location.reload();
  };

  const routes = headPortraitRoutes.map(_route => ({
    label: (
      <span onClick={() => navigate(_route.link)} className={styles.headSelectIcon}>
        <i className={`iconfont ${_route.icon}`} />
        {t(_route.title)}
      </span>
    ),
    key: _route.link,
  }));

  const menu = (
    <Menu
      items={[
        ...routes,
        // {
        //   label: (
        //     <span className={styles.headSelectIcon}>
        //       <i className='iconfont icon-icon-lang' />
        //       {t("Languages")}
        //     </span>
        //   ),
        //   key: '4',
        //   type: 'group',
        //   children: [
        //     {
        //       key: '4-1',
        //       label: (
        //         <div className={styles.lang_box}>
        //           <Button
        //             type="text"
        //             className={`${styles.langBtn} ${getLang === 'en_US' && styles.langActive}`}
        //             onClick={() => onLangChange('en_US')}
        //           >
        //             EN
        //           </Button>
        //           <Button
        //             type="text"
        //             className={`${styles.langBtn} ${getLang === 'zh_XG' && styles.langActive}`}
        //             onClick={() => onLangChange('zh_XG')}
        //           >
        //             繁
        //           </Button>
        //           <Button
        //             type="text"
        //             className={`${styles.langBtn} ${getLang === 'zh_CN' && styles.langActive}`}
        //             onClick={() => onLangChange('zh_CN')}
        //           >
        //             简
        //           </Button>
        //         </div>
        //       )
        //     }
        //   ]
        // },
        {
          type: 'divider',
        },
        {
          label: (
            <span onClick={onLogout} className={styles.headSelectIcon}>
              <i className='iconfont icon-icon-login' />
              {t("Log Out")}
            </span>
          ),
          key: '5',
        },
      ]}
    />
  );

  return (
    <div className={styles.head_portrait_box}>
      <Spin
        spinning={state.loading}
      >
        <Avatar
          src={state.userInfo.image ? `/api${state.userInfo.image}?sign=${process.env.SIGN}&appid=${process.env.APPID}&timestamp=${process.env.TIMESTAMP}&_=${new Date().getTime()}`: '/images/placeholder.jpg'}
          style={{ marginRight: 10 }}
        />
      </Spin>
      <Dropdown overlay={menu} arrow>
        <a onClick={(e) => e.preventDefault()}>
          <Space>
            {state.userInfo?.name ?? ''}
            <DownOutlined />
          </Space>
        </a>
      </Dropdown>
    </div>
  )
};

export default HeadPortraitSelect;